import { getAvailableSubscriptionsApi as generatedGetAvailableSubscriptionsApi } from '../generated/billing/getAvailableSubscriptions';

const getAvailableSubscriptionsApi = generatedGetAvailableSubscriptionsApi.enhanceEndpoints({
  endpoints: {
    getAvailableSubscriptions: {
      providesTags: [{ id: 'PLANS', type: 'Subscription' }],
    },
  },
});

export const { useGetAvailableSubscriptionsQuery } = getAvailableSubscriptionsApi;
